import React from 'react';
// Utility function to handle checkout redirects
export const handleCheckout = (e: React.MouseEvent) => {
  e.preventDefault();
  // Track the purchase click for analytics
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_category: 'Picadas Fáciles',
      content_name: 'Pack Completo Picadas Fáciles',
      currency: 'ARS',
      value: 17990.0
    });
  }
  // Redirect to the new checkout URL
  window.location.href = 'https://vhwt09-gz.myshopify.com/cart/42127271624747:1';
};